#import "~/graphql/fragments/Components/CraftLink.graphql"
fragment PromoBlock on promoBlockBlock_Entry {
    __typename
    title: blockTitle
    description
    richText {
        html
    }
    backgroundColor
    customBackgroundColor
    imagePosition
    image: promoImage {
        url
        w1212: url @transform(format: "webp", width: 1212)
        w1212_avif: url @transform(format: "avif", width: 1212)
        w606: url @transform(width: 606, format: "webp")
        w606_avif: url @transform(width: 606, format: "avif")
        w328: url @transform(width: 328, format: "webp")
        w328_avif: url @transform(width: 328, format: "avif")
    }
    linkField {
        ...CraftLinkField
    }
}
